import React from "react";
import styled from "styled-components";
import { resource } from "@app/common/localization/resource";
import { InvestButton } from "./InvestButton";

export const SectionKeys: React.VFC = () => (
  <StyledSection>
    <div className="container">
      <h1>{resource("landing.section1Title")}</h1>
      <div className="row">
        <div className="col-lg-4">
          <svg
            style={{ height: "100px", display: "block", margin: "0 auto 25px", fill: "var(--primary-color)" }}
            viewBox="0 0 111 111"
          >
            <path d="M5.579,105.449H17.387V78.7H5.579Zm14.583-32.3a2.775,2.775,0,0,1,2.777,2.775v32.3A2.777,2.777,0,0,1,20.162,111H2.8a2.777,2.777,0,0,1-2.777-2.775v-32.3A2.775,2.775,0,0,1,2.8,73.145Zm14.8,32.3H46.771V58.087H34.963ZM49.546,52.536a2.777,2.777,0,0,1,2.777,2.775v52.913A2.777,2.777,0,0,1,49.546,111H32.185a2.775,2.775,0,0,1-2.775-2.775V55.312a2.775,2.775,0,0,1,2.775-2.775Zm14.8,52.913H76.155V64.293H64.347ZM78.93,58.742a2.774,2.774,0,0,1,2.777,2.775v46.707A2.775,2.775,0,0,1,78.93,111H61.569a2.778,2.778,0,0,1-2.777-2.775V61.518a2.777,2.777,0,0,1,2.777-2.775Zm14.71,46.707h11.808V50.78H93.64Zm14.585-60.22A2.776,2.776,0,0,1,111,48v60.22A2.776,2.776,0,0,1,108.225,111H90.862a2.777,2.777,0,0,1-2.777-2.775V48a2.777,2.777,0,0,1,2.777-2.775ZM2.778,49.028a2.776,2.776,0,0,1-1.616-5.034L43.709,13.571a2.775,2.775,0,0,1,3.614.331L62.608,29.766l28.314-22.1-13.313,2.6a2.776,2.776,0,1,1-1.061-5.449L100.965.049a2.777,2.777,0,0,1,3.155,3.626L96.043,27.2a2.783,2.783,0,0,1-2.628,1.876,2.727,2.727,0,0,1-.9-.153,2.776,2.776,0,0,1-1.725-3.526l4.966-14.457-31.7,24.744a2.784,2.784,0,0,1-3.71-.262L44.987,19.479,4.392,48.511A2.778,2.778,0,0,1,2.778,49.028Z" />
          </svg>
          <p className="icon-text">{resource("landing.section1Text1")}</p>
        </div>
        <div className="col-lg-4">
          <svg
            style={{ height: "100px", display: "block", margin: "0 auto 25px", fill: "var(--primary-color)" }}
            viewBox="0 0 124 124"
          >
            <path d="M43.509,42.971A18.389,18.389,0,1,0,25.192,24.582,18.376,18.376,0,0,0,43.509,42.971ZM43.509,0A24.582,24.582,0,1,1,19.025,24.582,24.562,24.562,0,0,1,43.509,0ZM54.4,88.578a3.1,3.1,0,0,1,0,6.193H5.463A5.67,5.67,0,0,1,0,88.928,34.012,34.012,0,0,1,5.55,72.066c7.167-10.85,20.3-16.586,37.958-16.586a72.336,72.336,0,0,1,8.3.459,3.1,3.1,0,0,1-.7,6.15,67,67,0,0,0-7.6-.416c-15.5,0-26.848,4.779-32.82,13.816a28.474,28.474,0,0,0-4.5,13.089Zm38.549,28.548c5.7-4.352,24.445-20.673,24.874-47.256a36.245,36.245,0,0,1-24.844-6.441A36.284,36.284,0,0,1,68.12,69.869C68.459,97.216,87.123,112.895,92.946,117.125Zm30.99-51.011c1.619,37.031-28.014,56.581-29.278,57.394a3.07,3.07,0,0,1-3.3.022c-1.267-.794-30.995-19.84-29.348-57.417a3.088,3.088,0,0,1,3.72-2.894,29.881,29.881,0,0,0,25.018-5.848,3.068,3.068,0,0,1,2.207-.932.138.138,0,0,0,.032,0,3.062,3.062,0,0,1,2.2.932,29.885,29.885,0,0,0,25.018,5.848,3.089,3.089,0,0,1,3.722,2.894ZM100.892,79.343a3.089,3.089,0,1,1,4.325,4.412L91.57,97.251a3.072,3.072,0,0,1-4.342-.017l-6.517-6.542a3.089,3.089,0,0,1,4.36-4.377l4.355,4.37Z" />
          </svg>
          <p className="icon-text">{resource("landing.section1Text2")}</p>
        </div>
        <div className="col-lg-4">
          <svg
            style={{ height: "100px", display: "block", margin: "0 auto 25px", fill: "var(--primary-color)" }}
            viewBox="0 0 134 103"
          >
            <path d="M23.048,75.136A10.024,10.024,0,0,1,13.032,65.128V10.008A10.024,10.024,0,0,1,23.048,0h88.564a10.022,10.022,0,0,1,10.015,10.008v21.2a2.946,2.946,0,0,1-5.892,0v-21.2a4.126,4.126,0,0,0-4.123-4.121H23.048a4.126,4.126,0,0,0-4.123,4.121v55.12a4.126,4.126,0,0,0,4.123,4.121H43.674a2.944,2.944,0,1,1,0,5.887ZM128.335,94.894V47.731a1.768,1.768,0,0,0-1.766-1.766H60.3a1.769,1.769,0,0,0-1.768,1.766V94.894A1.769,1.769,0,0,0,60.3,96.66h66.266A1.768,1.768,0,0,0,128.335,94.894Zm-1.766-54.816a7.665,7.665,0,0,1,7.658,7.653V94.894a7.665,7.665,0,0,1-7.658,7.653H60.3a7.665,7.665,0,0,1-7.66-7.653V47.731a7.665,7.665,0,0,1,7.66-7.653ZM43.705,87.559H5.891v1.488c0,4.081,3.021,7.4,6.733,7.4H43.705a2.944,2.944,0,1,1,0,5.887H12.624C5.663,102.336,0,96.376,0,89.047V84.616a2.947,2.947,0,0,1,2.946-2.944h40.76a2.944,2.944,0,1,1,0,5.887Zm74.918-19.116a2.944,2.944,0,1,1-2.946,2.944A2.947,2.947,0,0,1,118.624,68.443Z" />
          </svg>
          <p className="icon-text">{resource("landing.section1Text3")}</p>
        </div>
      </div>
      <div className="button-container">
        <InvestButton>{resource("landing.btnStart2")}</InvestButton>
      </div>
    </div>
  </StyledSection>
);

const StyledSection = styled.section`
  padding: 80px 0;

  h1 {
    margin: 0 0 80px;
    font-size: 32px;
    font-weight: 700;
    color: var(--heading-color);
    text-align: center;
  }

  .icon-text {
    padding: 0 15px;
    font-size: 20px;
    font-weight: 700;
    text-align: center;
  }

  .button-container {
    margin: 40px 0 0;
    text-align: center;
  }
`;
